import React, { useEffect, useState } from "react";
import MainPagetitle from "../../../layouts/MainPagetitle";

const QrCode = (props) => {
  const isPanVerified = props.$store?.user?.is_pan_code_verified;
  const isAadharVerified = props.$store?.user?.is_aadhar_verified;
  const is_agreement_signed = props.$store?.user?.is_agreement_signed;

  const [qrcode, setQrcode] = useState(null);

  const generateQrCode = () => {
    props.apis.apiGenerateQrCode().then(async (response) => {
      setQrcode(response?.qrCode);
    });
  };

  const handleSubmit = (e, data) => {
    let payload = {
      language: data?.language,
    };

    props.apis.apiGetQrCode(payload).then(async (response) => {
      let data = await response;
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "QR-code.png"); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };

  const getBackLink = () => {
    return "/app/kyc";
  };

  useEffect(() => {
    generateQrCode();

    console.log({ isPanVerified, isAadharVerified, is_agreement_signed });

    if (!isPanVerified || !isAadharVerified || !is_agreement_signed) {
      swal2
        .fire({
          title: "Account Verification Pending",
          text: "Please complete your profile",
          icon: "info",
          iconColor: "#234C9B",
        })
        .then((result) => {
          if (result.isConfirmed) {
            props.navigate("/app/myprofile");
          }
        });
    }
  }, []);

  return (
    <>
      <MainPagetitle
        mainTitle="My QR Code"
        backLink={getBackLink()}
        pageIcon={imagepaths.qrCodeIconActive}
      />
      {isPanVerified && isAadharVerified && is_agreement_signed ? (
        <div className="container-fluid">
          <div className="kyc_container">
            <h2 className="heading-title">My QR Code</h2>

            <div className="row">
              <div className="col-12 col-md-6 col-lg-4">
                <p>
                  Your unique QR code is ready- use it to collect leads and grow
                  your business. Lets get started!
                </p>
                <AppForm
                  className="container mb-3 px-0"
                  onSubmit={handleSubmit}
                >
                  <AppInput
                    name="language"
                    label="Select Language"
                    type="select"
                    options={_enum.QR_LANGUAGES}
                    required
                  ></AppInput>

                  <button type="submit" className="btn btn-primary w-auto ms-3">
                    <i className="fa fa-download me-2"></i>
                    <span>Download QR Code</span>
                  </button>
                </AppForm>
              </div>
              <div className="col-12 col-md-6 col-lg-8">
                <img src={qrcode} alt="qr code" className="qr_code_img" />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default constore(QrCode);
